import { StyledLinearProgress } from './ProgressBar.styled'

export type ProgressBarProps = {
  step: number
  maximumStep: number
}

export const ProgressBar = ({ step, maximumStep }: ProgressBarProps) => (
  <StyledLinearProgress
    color="primary"
    variant="determinate"
    value={Math.round((step / maximumStep) * 100)}
  />
)
